export const GET_DEPARTMENT_REQUEST = 'GET_DEPARTMENT_REQUEST';
export const GET_DEPARTMENT_SUCCESS = 'GET_DEPARTMENT_SUCCESS';
export const GET_DEPARTMENT_FAILURE = 'GET_DEPARTMENT_FAILURE';
export const GET_DEPT_INTG_REQUEST = 'GET_DEPT_INTG_REQUEST';
export const GET_DEPT_INTG_SUCCESS = 'GET_DEPT_INTG_SUCCESS';
export const GET_DEPT_INTG_FAILURE = 'GET_DEPT_INTG_FAILURE';
